import { render, staticRenderFns } from "./MesadAyuda.vue?vue&type=template&id=2dbd19f3&scoped=true&"
import script from "./MesadAyuda.vue?vue&type=script&lang=js&"
export * from "./MesadAyuda.vue?vue&type=script&lang=js&"
import style0 from "./MesadAyuda.vue?vue&type=style&index=0&id=2dbd19f3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbd19f3",
  null
  
)

export default component.exports